import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '@docpath/linces-angular-components/common';
import { RoutingPath } from 'src/app/constants/routing-path';
import { CloudService } from 'src/app/shared/services/cloud.service';

@Component({
  selector: 'app-cloud',
  templateUrl: './cloud.component.html'
})

export class CloudComponent implements OnInit {

  constructor(
    private readonly loginService: LoginService,
    private readonly router: Router,
    private readonly cloudService: CloudService
  ) {}

  ngOnInit(): void {
    this.login();
  }

  private login() {

    this.loginService.loginByToken({
      queryParameters: { accessToken: this.cloudService.getAccessTokenCookie(), refreshToken: this.cloudService.getRefreshTokenCookie() },
      catchError: () => {
        this.router.navigate([ RoutingPath.PATH_LOGIN ]);
      },
      suscribe: () => {
        this.cloudService.updateCookies();
        this.router.navigate([ RoutingPath.PATH_HOME ]);
      }
    });

  }

}
